import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { random } from 'lodash';

import Graph from './graph/Graph';
import EditorSidebar from './sidebar/EditorSidebar';

import UpdateCircle from './update-circle/UpdateCircle';
import UnauthorizedModal from './UnauthorizedModal';

import UserPresence from './user-presence/UserPresence';
import '../../App.css';
import { useCurrentBoardState, useCurrentUser } from '../../services/state';
import Header from './header/EditorHeader';
import { login as deepstreamLogin, getRecord } from '../../services/deepstream';
import { LoadingSpinner } from '../common/loading-spinner/LoadingSpinner';

const randomColor = () => `rgb(${random(0, 255)}, ${random(0, 255)}, ${random(0, 255)})`;

const Editor = () => {
  const { boardId } = useParams();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isBoardReady, setIsBoardReady] = useState(false);

  const [errorModalVisible, setErrorModalVisible] = useState(false);

  const { id: userId, email: userEmail } = useCurrentUser();
  const boardState = useCurrentBoardState();
  const { userRole, moveWithChildren } = boardState.get();
  const canEditProject = ['editor', 'owner'].includes(userRole);

  const moveWithChildrenRef = useRef(true);
  moveWithChildrenRef.current = moveWithChildren;

  useEffect(() => {
    deepstreamLogin({ userId, boardId })
      .then(async ({ userRole }) => {
        setIsLoggedIn(true);
        boardState.merge({ id: boardId, userRole });

        const userRecord = getRecord(`project/${boardId}/user/${userId}`);
        const boardRecord = getRecord(`project/${boardId}`);

        await Promise.all([userRecord.whenReady(), boardRecord.whenReady()]);

        userRecord.set({ id: userId, email: userEmail, color: randomColor() });
        boardRecord.subscribe('title', newTitle => boardState.merge({ title: newTitle }), true);
        boardRecord.subscribe('ready', setIsBoardReady, true);
      })
      .catch(error => {
        if (error.reason === 'INVALID_AUTHENTICATION_DETAILS') {
          setErrorModalVisible(true);
        } else {
          console.log('unknown deepstream error', error);
        }
      });

    return () => {
      setIsLoggedIn(false);
      setIsBoardReady(false);
    };
  }, [userId, boardId]);

  if (!errorModalVisible && (!isLoggedIn || !isBoardReady)) {
    return (
      <div style={{ textAlign: 'left' }}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className="content-wrapper">
        <div id="circlyapp-editor-canvas" className="App">
          {canEditProject && <EditorSidebar />}
          <Graph />

          <UpdateCircle />

          <UserPresence />

          <UnauthorizedModal isOpen={errorModalVisible} />
        </div>
      </div>
    </>
  );
};

export default Editor;
